
export default {
  photo: 'Avatar',
  save: 'Save',
  companyName: 'Company Name',
  firstName: 'First Name',
  lastName: 'Last Name',
  timezone: 'Timezone'
};



// WEBPACK FOOTER //
// ./src/components/forms/profile-form/ProfileForm.messages.js